import { SectionHeader } from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "Evaluate first",
    body: "Every safe and lock is different. Jose assesses your specific job before recommending an approach — no guesswork, no automated online estimates.",
  },
  {
    n: "02",
    title: "Talk it through",
    body: "You speak directly with the person doing the work. We discuss the details by phone so there are no surprises when we arrive.",
  },
  {
    n: "03",
    title: "Do it right",
    body: "With the proper tools, equipment and experience, we handle the job carefully — including the difficult ones other companies turn down.",
  },
];

export const Manifesto = () => (
  <section
    className="border-y border-white/10 bg-ink-surface py-24 md:py-32"
    data-testid="manifesto"
  >
    <div className="mx-auto max-w-[1440px] px-5 md:px-8">
      <SectionHeader overline="How We Work" title="The Velasco standard" />
      <div className="mt-14 grid gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1} className="bg-ink-surface">
            <div className="flex h-full flex-col p-8 md:p-10">
              <span className="text-stroke-gold font-heading text-6xl font-black">{c.n}</span>
              <h3 className="mt-6 font-heading text-2xl font-bold text-white">{c.title}</h3>
              <p className="mt-3 leading-relaxed text-steel">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
